// import ModalForm from "./Form";
import PlacementTestTableForm from "./PlacementTestTableForm";
import {
	PLACEMENT_TEST_CONTENT,
	DATATABLE_EXPORT,
} from "../../../../../../../Config/ApiUrl";
import * as actions from "../../../../../../../Config/ApiUrl";
import {urlGenerator} from "../../../../../../../Helpers/AxiosHelper";

export const PlacementTestTableSchema = {
	components: { PlacementTestTableForm },

	data() {
		return {
			DATATABLE_EXPORT,
			isAddEditModalActive: false,
			deleteConfirmationModalActive: false,
			deleteLoader: false,
			selectedUrl: "",
			Endpoint: PLACEMENT_TEST_CONTENT + "?placement_id=" + this.placementId,
			tableId: "placement-test-table",
			formId: "placement-test-table-form",
			rowData: {},
			tableColumns: [
				{
					title: "Skill Test",
					type: "text",
					key: "skill_test",
				},
				{
					title: "Test Content",
					type: "text",
					key: "test_content",
				},
				{
					title: "Material",
					type: "text",
					key: "material",
				},
				{
					title: "Code",
					type: "text",
					key: "code",
				},
				{
					title: "Score",
					type: "text",
					key: "score",
				},
                {
					title: "Duration",
					type: "text",
					key: "duration",
				},
                {
					title: "Image",
					type: "custom-html",
					key: "image",
					modifier: (value) => {
						return `<img src="${urlGenerator(value)}" alt="image" class="img-fluid" style="width: 200px; height: auto;" />`;
					},
				},
			],
			actionObj: {
				title: this.$t("action"),
				type: "action",
			},
			options: {
				name: "PlacementTestTable",
				url: PLACEMENT_TEST_CONTENT + "?placement_id=" + this.placementId,
				showHeader: true,
				enableHighlights: true,
				// enableRowSelect: true,
				enableSaveFilter: true,
				columns: [],
				actions: [
					{
						title: this.$t("edit"),
						icon: "edit",
						type: "none",
						// component: "app-add-modal",
						component: "placement-test-table-form",
						modalId: "placement-test-table-form",
					},
					{
						title: this.$t("delete"),
						icon: "trash",
						type: "none",
						component: "app-confirmation-modal",
						modalId: "demo-delete",
					},
				],
				showFilter: true,
				showSearch: true,
				showCount: true,
				showClearFilter: true,
				paginationType: "pagination",
				responsive: true,
				rowLimit: 3,
				showAction: true,
				orderBy: "desc",
				actionType: "default",
			},
		};
	},
	methods: {},
};
